import { Input, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import FormWrapper from './FormWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchRoles } from '../../../store/slices/role-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const RoleForm = () => {
    const [roleName, setRoleName] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: roles } = useSelector((state) => state.role);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchRoles());
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && roles.length) {
            const ID = searchParams.get('id');
            const selectedRole = roles.filter((item) => item.role_id === ID);
            setRoleName(selectedRole[0].role_name);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, roles]);

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'role_name': roleName,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.role_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/role/${MODE === 'ADD' ? 'create' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/role-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setRoleName('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Role</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Role Name:</label>
                    <Input 
                        onChange={(e) => setRoleName(e.target.value)} 
                        value={roleName}
                        size='large' 
                        placeholder='Role Name' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default RoleForm;


